import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { ITabNavigationItem } from 'common/models';

interface IComponentProps {
  items: ITabNavigationItem[];
}

export const TabNavigation: FC<IComponentProps> = ({ items }) => {
  return (
    <div className="tab-navigation">
      {items.map((item) => {
        return (
          <NavLink
            className={({ isActive }) => (isActive ? 'text-h1 color-black' : 'text-h1 color-dark-grey')}
            key={item.path}
            to={item.path}
          >
            {item.label}
          </NavLink>
        );
      })}
    </div>
  );
};
